// extracted by mini-css-extract-plugin
export default {"lead__Approval__View":"styles_lead__Approval__View__HWpg1","back__Btn__Wrap":"styles_back__Btn__Wrap__481mk","back__Btn":"styles_back__Btn__5EoTa"};